import AdminTableFiltersCard from "../ui/AdminTableFiltersCard";

type AdminAuditFiltersProps = {
  search: string;
  admin: string;
  pageSize: number;
  onSearchChange: (value: string) => void;
  onAdminChange: (value: string) => void;
  onPageSizeChange: (value: number) => void;
};

const AdminAuditFilters = ({
  search,
  admin,
  pageSize,
  onSearchChange,
  onAdminChange,
  onPageSizeChange,
}: AdminAuditFiltersProps) => {
  return (
    <AdminTableFiltersCard>
      <div className="flex flex-wrap items-end gap-3">
        <div className="min-w-[280px] flex-[1.8_1_320px]">
          <label htmlFor="admin-audit-filter-search" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Search
          </label>
          <input
            id="admin-audit-filter-search"
            type="text"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Action, target, reason"
            className="w-full rounded-lg border border-myteengig-border bg-white px-4 py-3 text-base text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          />
        </div>
        <div className="min-w-[220px] flex-[1.1_1_240px]">
          <label htmlFor="admin-audit-filter-admin" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Admin
          </label>
          <input
            id="admin-audit-filter-admin"
            type="text"
            value={admin}
            onChange={(event) => onAdminChange(event.target.value)}
            placeholder="Email or name"
            className="w-full rounded-lg border border-myteengig-border bg-white px-4 py-3 text-base text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          />
        </div>
        <div className="min-w-[110px] flex-[0_1_120px]">
          <label htmlFor="admin-audit-filter-page-size" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Rows
          </label>
          <select
            id="admin-audit-filter-page-size"
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
            className="h-[50px] rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
          </select>
        </div>
      </div>
    </AdminTableFiltersCard>
  );
};

export default AdminAuditFilters;
